import { useQuery } from '@tanstack/react-query';
import { tabelas as apiTabelas } from '../api/endpoints';
import { formatarDataCigam } from '../lib/formatos';
import { Aviso } from './Aviso';
import { Selecao } from './Campo';

export const CHAVE_TABELAS = ['tabelas'];

/** Escolha da tabela de preço do CIGAM, com a validade ao lado e as vencidas marcadas (SPEC §4.3). */
export function SeletorTabela({ valor, aoMudar, className }: { valor: string; aoMudar: (codigo: string) => void; className?: string }) {
  const { data, isPending, error } = useQuery({ queryKey: CHAVE_TABELAS, queryFn: apiTabelas.listar, staleTime: 5 * 60_000 });

  if (error) return <Aviso tipo="erro">{error.message}</Aviso>;
  const escolhida = data?.tabelas.find((t) => t.codigo === valor);

  return (
    <div className={className}>
      <Selecao
        rotulo="Tabela de preço"
        value={valor}
        disabled={isPending}
        onChange={(e) => aoMudar(e.target.value)}
        ajuda={
          escolhida ? (
            <span className={escolhida.vencida ? 'font-medium text-erro' : undefined}>
              Validade no CIGAM: {formatarDataCigam(escolhida.validade)}
              {escolhida.vencida && ' — vencida'}
            </span>
          ) : undefined
        }
      >
        <option value="">{isPending ? 'Carregando tabelas…' : 'Escolha a tabela'}</option>
        {data?.tabelas.map((t) => (
          <option key={t.codigo} value={t.codigo}>
            {t.codigo} — {t.descricao} · até {formatarDataCigam(t.validade)}
            {t.vencida ? ' (VENCIDA)' : ''}
          </option>
        ))}
      </Selecao>
    </div>
  );
}
